import React from "react";

export enum WidgetType {
  Image = "image",
  Citation = "citation",
}

export type WidgetId = string;

type WidgetComponent<T extends Record<string, unknown>> = React.FC<{
  values?: Partial<T>;
  id: WidgetId;
  ids?: WidgetId[]; // Optional array for grouped widgets
  type: WidgetType;
  messageId: string;
  chatId: string;
}>;

export type ImageValues = {
  "image-id": string;
  "alt-text": string;
};
export type CitationValues = {
  src: string;
  title: string;
  page: number;
  excerpt: string;
};
export type ImageWidget = WidgetComponent<ImageValues>;
export type CitationWidget = WidgetComponent<CitationValues>;

export const WidgetContext = React.createContext<
  | {
      widgets: {
        [WidgetType.Image]: ImageWidget;
        [WidgetType.Citation]: CitationWidget;
      };
      widgetState?: Partial<{
        [WidgetType.Image]: Record<WidgetId, Partial<ImageValues>>;
        [WidgetType.Citation]: Record<WidgetId, Partial<CitationValues>>;
      }>;
      messageId: string;
      chatId: string;
    }
  | undefined
>(undefined);
